import React, { useState, useEffect } from 'react';
import ItemsCarousel from 'react-items-carousel';

function PictureSlider (props){
    const [autoPlay, setAutoplay] = useState(props.autoPlay || false);
    const [activeItem, setActiveItem] =   useState(0);
    let numberOfCards = props.numberOfCards || 3;
    let remainder = numberOfCards%2;
    let numberOfItems = props.items.length;
    let offset = ((numberOfCards - remainder) / 2) - (remainder === 1 ? 1 : 2) + 1;

    useEffect(() => {
      if (autoPlay !== false) {
        setTimeout(() => {
          changeSlide((activeItem + 1)%numberOfItems);
        }, autoPlay);
      }
    });

    function changeSlide(currentItem){
      setActiveItem(currentItem);
    }

    function getStatus(index){
      if (index === activeItem)
        return "active";
      if (index === activeItem - 1)
        return "prev";
      if (index === activeItem + 1)
        return "next";

      return "inactive";
    }


    return (
      <React.Fragment>

        <div style={{padding:0,maxWidth:"100%",margin:"0", overflowY: 'hidden'}}>
    <ItemsCarousel infiniteLoop={false}
    gutter={60}
    activePosition='left'
    disableSwipe={false}
    numberOfCards={numberOfCards}
    slidesToScroll={1}
    onSelect={changeSlide}
    showSlither={true}
    firstAndLastGutter={true}
    activeItemIndex={activeItem-offset}
    requestToChangeActive={changeSlide}>
{props.items.map((p,i) => { 
  
  let style = {};
  if (p.source)
    style.backgroundImage = `url("${p.source}")`;

  return (<div className={`sliding-picture sliding-picture-${getStatus(i)}`}
      onClick={() => {setAutoplay(false); changeSlide(i);}}
    key={p.source}
    style={style}
  >{p.element}</div>)})}
    </ItemsCarousel>

    </div>
      </React.Fragment>);
}


export default PictureSlider;